import { Component } from '@angular/core';

@Component({
  selector: 'ngx-databases',
  template: `<router-outlet></router-outlet>`,
})
export class DatabasesComponent {
}
